// import request from '@/utils/request';
import request from '../../../utils/request'
export const queryFormSettingPageList = (data: any) => {
  // 业务表单列表数据
  return request({
    url: 'zqcrm/businessFormSetting/queryFormSettingPageList',
    method: 'POST',
    data,
  })
}
export const updateStatus = (data: any) => {
  // 业务表单开关 是否必填 1 是否启用 2
  return request({
    url: 'zqcrm/businessFormSetting/updateStatus',
    method: 'POST',
    data,
  })
}
export const queryFormTypeList = (data: any): any => {
  // 业务表单搜索条件数据
  return request({
    url: 'zqcrm/businessFormSetting/queryFormTypeList',
    method: 'GET',
    params: data,
  })
}
export const formRemove = (data: any): any => {
  // 业务表单搜索条件数据
  return request({
    url: 'zqcrm/businessFormSetting/remove',
    method: 'GET',
    params: data,
  })
}
export const formBusinessAdd = (data: any): any => {
  // 业务表单新增
  return request({
    url: 'zqcrm/businessFormSetting/add',
    method: 'POST',
    data,
  })
}
//
export const formBusinessEdit = (data: any): any => {
  // 业务表单编辑
  return request({
    url: 'zqcrm/businessFormSetting/edit',
    method: 'POST',
    data,
  })
}
export const deleteProductForm = (data: any): any => {
  // 业务表单 详情数据
  return request({
    url: 'zqcrm/businessFormSetting/getInfo',
    method: 'GET',
    params: data,
  })
}
export const queryOrderExamineList = (data: any): any => {
  // 订单审批列表页面
  return request({
    url: 'zqcrm/orderExamine/queryOrderExamineList',
    method: 'POST',
    data,
  })
}
export const getProductList = (data: any): any => {
  // 业务产品 获取分页
  return request({
    url: 'zqcrm/product/product/getProductList',
    method: 'POST',
    data,
  })
}
export const businessGetInfo = (data: any): any => {
  // 业务产品 详情接口
  return request({
    url: 'zqcrm/product/product/getProductById',
    method: 'POST',
    data,
  })
}
export const editProduct = (data: any): any => {
  // 业务产品 编辑接口
  return request({
    url: 'zqcrm/product/product/editProduct',
    method: 'POST',
    data,
  })
}
export const queryAllTemplate = (data: any): any => {
  // 业务产品 合同模板
  return request({
    url: 'zqcrm/contractTemp/queryAllTemplate ',
    method: 'GET',
    params: data,
  })
}
export const getProductDirectoryList = (data?: any): any => {
  // 业务产品 产品手册目录
  return request({
    url: 'zqcrm/product/product/getProductDirectoryList',
    method: 'GET',
  })
}
export const queryProductBrochureList = (data: any): any => {
  // 业务产品 产品手册列表
  return request({
    url: 'zqcrm/product/product/queryProductBrochureList',
    method: 'POST',
    data
  })
}
export const getProductBrochureById = (data: any): any => {
  // 业务产品 查询单个手册列表
  return request({
    url: 'zqcrm/product/product/getProductBrochureById',
    method: 'GET',
    params: data,
  })
}
export const getProductBrochureFileList = (data?: any): any => {
  // 业务产品 产品手册下载
  return request({
    url: 'zqcrm/product/product/getProductBrochureFileList',
    method: 'GET',
  })
}
export const getCustomerBalanceList = (data: any): any => {
  // 客户余额列表
  return request({
    url: 'zqcrm/balance/getCustomerBalanceList',
    method: 'POST',
    data,
  })
}
export const getRechargeRecordList = (data: any): any => {
  // 余额充值列表
  return request({
    url: 'zqcrm/recharge/getRechargeRecordList',
    method: 'POST',
    data,
  })
}
export const addRecharge = (data: any): any => {
  // 余额充值新增
  return request({
    url: 'zqcrm/recharge/addRecharge',
    method: 'POST',
    data,
  })
}
export const getRechargeTarget = (data: any): any => {
  // 余额充值 公司/个人 充值
  return request({
    url: 'zqcrm/recharge/getRechargeTarget',
    method: 'POST',
    data,
  })
}
export const recordListDel = (data: any): any => {
  // 余额充值删除
  return request({
    url: 'zqcrm/recharge/del',
    method: 'GET',
    params: data,
  })
}
export const getPayCompany = (data: any): any => {
  // 余额充值充值主体
  return request({
    url: 'zqcrm/recharge/getPayCompany',
    method: 'GET',
    params: data,
  })
}
export const getCustomerInfo = (data: any): any => {
  // 客户余额详情页
  return request({
    url: 'zqcrm/balance/getCustomerInfo',
    method: 'POST',
    data,
  })
}
export const getSwitchSetList = (data: any): any => {
  // 订单限制开关 列表
  return request({
    url: 'zqcrm/switchSet/getSwitchSetList',
    method: 'POST',
    data,
  })
}
export const updateById = (data: any): any => {
  // 订单限制开关 修改状态/描述/信息
  return request({
    url: 'zqcrm/switchSet/updateById',
    method: 'POST',
    data,
  })
}
export const getSwitchSetInfo = (data: any): any => {
  // 订单限制开关 配置工单回显
  return request({
    url: 'zqcrm/switchSet/getSwitchSetInfo',
    method: 'GET',
    params: data,
  })
}
export const getProductListSwitch = (data: any): any => {
  // 订单限制开关 配置工单树 数据
  return request({
    url: 'zqcrm/switchSet/getProductList',
    method: 'POST',
    data,
  })
}
export const bindProduct = (data: any): any => {
  // 订单限制开关 配置工单树 数据
  return request({
    url: 'zqcrm/switchSet/bindProduct',
    method: 'POST',
    data,
  })
}
// 获取订单限制开关 可选公司
export const getCompanySetting = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/getCompanySetting',
    method: 'GET',
    params: data,
  })
}
// 订单限制开关 配置收款公司提交
export const updateCompanySetting = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/updateCompanySetting',
    method: 'POST',
    data,
  })
}
// 正企付款主体配置
export const updateWxPayeeStatus = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/updateWxPayeeStatus',
    method: 'GET',
    params: data,
  })
}
// 业务产品删除接口
export const delProductById = (ids: any): any => {
  // 业务产品删除接口
  return request({
    url: 'zqcrm/product/product/delProductById',
    method: 'DELETE',
    params: ids,
  })
}
// 客户检索
export const queryAllCustomer = (data: any): any => {
  // 业务产品删除接口
  return request({
    url: 'zqcrm/customerStatusTag/queryAllCustomer',
    method: 'POST',
    data,
  })
}
// 业务线列表
export const queryProductTypeList = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/queryProductTypeList',
    method: 'GET',
    params: data,
  })
}
// 发起签约 周期性产品接口
export const queryProductListPeriodicity = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/queryProductList',
    method: 'GET',
    params: data,
  })
}
// 根据业务线查询产品列表
export const queryProductListByType = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/queryProductListByType',
    method: 'GET',
    params: data,
  })
}
// 根据父级id查询子产品列表
export const queryChildProductList = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/queryChildProductList',
    method: 'GET',
    params: data,
  })
}
// 根据产品id查询业务表单列表
export const queryFormSettingListByProductId = (data: any): any => {
  return request({
    url: 'zqcrm/businessFormSetting/queryFormSettingListByProductId',
    method: 'GET',
    params: data,
  })
}
// 发起签约 甲方公司名称 甲方个人名称 type 1 公司 2 个人
export const queryCustomerListByType = (data: any): any => {
  return request({
    url: 'zqcrm/customerStatusTag/queryCustomerListByType',
    method: 'GET',
    params: data,
  })
}
// 发起签约 收款方式列表
export const queryPayTypeList = (data: any): any => {
  return request({
    url: 'zqcrm/order/queryPayTypeList',
    method: 'GET',
    params: data,
  })
}
// 发起签约 新增订单
export const addOrder = (data: any): any => {
  return request({
    url: 'zqcrm/order/addOrder',
    method: 'POST',
    data,
  })
}
// 发起签约 编辑订单
export const editOrder = (data: any): any => {
  return request({
    url: 'zqcrm/order/editOrder',
    method: 'POST',
    data,
  })
}
// 合同模版 管理模版列表
export const getContractTempList = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/getContractTempList',
    method: 'POST',
    data,
  })
}
// 合同模版 管理模版 新增模版
export const addContractTemp = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/addContractTemp',
    method: 'POST',
    data,
  })
}
// 合同模版 管理模版 模版刷新
export const refreshById = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/refreshById',
    method: 'GET',
    params: data,
  })
}
// 合同模版 管理模版 预览模版
export const getTemplateDetailById = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/getTemplateDetailById',
    method: 'GET',
    params: data,
  })
}
// 合同模版 管理模版 编辑模版
export const editTemplateById = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/editTemplateById',
    method: 'GET',
    params: data,
  })
}
// 合同模版 管理模版 删除模版
export const delContractTempById = (data: any): any => {
  return request({
    url: 'zqcrm/contractTemp/delContractTempById',
    method: 'GET',
    params: data,
  })
}
// 发起签约 第一步回显接口
export const getOrderInfo = (data: any): any => {
  return request({
    url: 'zqcrm/order/getOrderInfo',
    method: 'GET',
    params: data,
  })
}
// 全部订单 订单列表  ---- 是否查询下属 subordinateFlag  0-否  1-是
export const queryOrderPageList = (data: any): any => {
  return request({
    url: 'zqcrm/order/queryOrderPageList',
    method: 'POST',
    data,
  })
}
// 全部订单 订单列表 合同状态下拉框
export const contractStatusList = (data: any): any => {
  return request({
    url: 'zqcrm/order/contractStatusList',
    method: 'GET',
    params: data,
  })
}
// 全部订单 订单列表 订单状态列下拉框
export const orderStatusList = (data: any): any => {
  return request({
    url: 'zqcrm/order/orderStatusList',
    method: 'GET',
    params: data,
  })
}
// 全部订单 订单列表 列表删除接口
export const deleteOrderById = (data: any): any => {
  return request({
    url: 'zqcrm/order/deleteOrderById',
    method: 'GET',
    params: data,
  })
}
// 发起签约第一步提交之前的报警弹窗
export const verifyOrder = (data: any): any => {
  return request({
    url: 'zqcrm/order/verifyOrder',
    method: 'POST',
    data,
  })
}
// 确认订单
export const confirmOrder = (data: any): any => {
  return request({
    url: 'zqcrm/order/confirmOrder',
    method: 'GET',
    params: data,
  })
}
// 订单合同附件申请签署
export const applyOrderContractSign = (endpoint: string, data: any): any => {
  return request({
    url: `zqcrm/order/${endpoint}`,
    method: 'POST',
    data,
  })
}
// 根据签署任务ID获取合同附件预览地址
export const getPreviewUrlByTaskId = (signTaskId: string | number): any => {
  return request({
    url: 'zqcrm/order/getPreviewUrlByTaskId',
    method: 'GET',
    params: { signTaskId },
  })
}
// 发起签约第一步 提交特批
export const agreeSpecialApprove = (data: any): any => {
  return request({
    url: 'zqcrm/order/agreeSpecialApprove',
    method: 'POST',
    data,
  })
}
// 发起签约第一步 添加补充协议
export const addAideAgreement = (data: any): any => {
  return request({
    url: 'zqcrm/order/addAideAgreement',
    method: 'POST',
    data,
  })
}
// 发起签约第三步 创建该订单的审批流程
export const approvalProcess = (data: any): any => {
  return request({
    url: 'zqcrm/order/approvalProcess',
    method: 'POST',
    data,
  })
}
// 客户分发
export const getCrmAdmin = (data: any): any => {
  return request({
    url: 'zqcrm/work/getCrmAdmin',
    method: 'GET',
    params: data,
  })
}
// 发起签约第四步 获取二维码
export const generateCode = (data: any): any => {
  return request({
    url: 'zqcrm/order/generateCode',
    method: 'GET',
    params: data,
  })
}
// 发起签约第四步 获取二维码
export const generateQRCode = (data: any): any => {
  return request({
    url: 'zqcrm/order/generateQRCode',
    method: 'GET',
    params: data,
  })
}
// 发起签约第二步 下载
export const getDownUrl = (data: any): any => {
  return request({
    url: 'zqcrm/order/getDownUrl',
    method: 'GET',
    params: data,
  })
}
// 全部订单 详情 客户订单详情
export const getOrderInfoByOrderId = (data: any): any => {
  return request({
    url: 'zqcrm/order/getOrderInfoByOrderId',
    method: 'GET',
    params: data,
  })
}
// 回款审批 列表接口
export const returnedList = (data: any): any => {
  return request({
    url: 'zqcrm/examine/cash_examine/list',
    method: 'POST',
    data,
  })
}
// 回款审批 查看详情接口
export const returnedDetail = (id: any): any => {
  return request({
    url: `zqcrm/examine/cash_examine/detail/${id}`,
    method: 'GET',
  })
}
// 回款审批 审批查看详情接口
export const returned = (id: any): any => {
  return request({
    url: `zqcrm/examine/cash_examine/${id}`,
    method: 'GET',
  })
}
// 回款审批 审批确定接口
export const examineApproval = (data: any): any => {
  return request({
    url: 'zqcrm/examine/cash_examine/approval',
    method: 'POST',
    data,
  })
}
// 发签第三步合同信息页面 下载附件清单
export const getAgreementDownUrl = (data: any): any => {
  return request({
    url: 'zqcrm/order/getAgreementDownUrl',
    method: 'GET',
    params: data,
  })
}
// 发签第四步 审批列表
export const orderApprovalList = (data: any): any => {
  return request({
    url: 'zqcrm/order/orderApprovalList',
    method: 'GET',
    params: data,
  })
}
// 待收款列表接口
export const orderPayInfoList = (data: any): any => {
  return request({
    url: 'zqcrm/orderPayInfo/list',
    method: 'POST',
    data,
  })
}
// 订单详情页 根据订单id获取订单信息
export const getOrderInfoById = (id: any): any => {
  return request({
    url: `zqcrm/orderPayInfo/list/${id}`,
    method: 'GET',
  })
}
// 余额充值页面 二维码弹窗接口
export const payCode = (data: any): any => {
  return request({
    url: 'zqcrm/recharge/payCode',
    method: 'GET',
    params: data,
  })
}
// 回款审批 审批确定接口
export const cashApproval = (data: any): any => {
  return request({
    url: 'zqcrm/examine/cash_examine/approval',
    method: 'POST',
    data,
  })
}
// 待收款 发起收款弹窗回显接口
export const getOrderPayInfoById = (id: any): any => {
  return request({
    url: `zqcrm/orderPayInfo/toReceivePayment/${id}`,
    method: 'GET',
  })
}
// 待收款 发起收款弹窗提交接口
export const doReceivePayment = (data: any): any => {
  return request({
    url: 'zqcrm/orderPayInfo/doReceivePayment',
    method: 'put',
    data,
  })
}
// 待收款页面 导出
export const exportOrderPayInfo = (data: any): any => {
  return request({
    url: 'zqcrm/orderPayInfo/export',
    method: 'post',
    data,
    // 指定请求类型为二进制流
    // 不写可能会造成下载成功的图片和文件是看不到和没有内容的
    responseType: 'blob',
  })
}
// 待收款 页面 二维码
export const barCodeShow = (id: any): any => {
  return request({
    url: `zqcrm/orderPayInfo/barCodeShow/${id}`,
    method: 'GET',
  })
}
// 待收款页面 合并支付
export const mergePay = (data: any): any => {
  return request({
    url: 'zqcrm/orderPayInfo/merge',
    method: 'POST',
    data,
  })
}
// 全部订单 合并支付
export const orderMerge = (data: any): any => {
  return request({
    url: 'zqcrm/order/merge',
    method: 'POST',
    data,
  })
}
// 待收款 拆分
export const splitPay = (id: any): any => {
  return request({
    url: `zqcrm/orderPayInfo/split/${id}`,
    method: 'put',
  })
}
// 待收款 详情
export const accountsDetail = (id: any): any => {
  return request({
    url: `zqcrm/orderPayInfo/${id}`,
    method: 'GET',
  })
}
// 全部订单 订单状态
export const progressOnApprovals = (data: any): any => {
  return request({
    url: 'zqcrm/orderExamine/progressOnApprovals',
    method: 'GET',
    params: data,
  })
}
// 合同模板 - 合同列表接口
export const getContractList = (data: any): any => {
  return request({
    url: 'zqcrm/contract/getContractList',
    method: 'POST',
    data,
  })
}
// 合同模板 - 合同附件（时清）列表接口
export const getContractAttachList = (data: any): any => {
  return request({
    url: 'zqcrm/contract/getContractAttachList',
    method: 'POST',
    data,
  })
}
// 订单审批 同意
export const orderAgree = (data: any): any => {
  return request({
    url: 'zqcrm/orderExamine/agree',
    method: 'POST',
    data,
  })
}
// 订单审批 拒绝
export const orderRefuse = (data: any): any => {
  return request({
    url: 'zqcrm/orderExamine/refuse',
    method: 'POST',
    data,
  })
}
// 合同列表 合同归档
export const placeOnFile = (data: any): any => {
  return request({
    url: 'zqcrm/contract/fileContractById',
    method: 'GET',
    params: data,
  })
}
// 合同列表 待我方签署
export const fileSign = (data: any): any => {
  return request({
    url: 'zqcrm/contract/signContractById',
    method: 'GET',
    params: data,
  })
}
// 合同列表 预览合同
export const previewContract = (data: any): any => {
  return request({
    url: 'zqcrm/contract/previewContractById',
    method: 'GET',
    params: data,
  })
}
// 合同列表 合同审批
export const contractApproval = (data: any): any => {
  return request({
    url: 'zqcrm/contract/examineContractById',
    method: 'POST',
    data,
  })
}
// 合同列表 回收合同
export const recycleContract = (data: any): any => {
  return request({
    url: 'zqcrm/contract/recoveryContractById',
    method: 'GET',
    params: data,
  })
}
// 合同列表 确认回收合同
export const confirmRecycleContract = (data: any): any => {
  return request({
    url: 'zqcrm/contract/recoveriedContractById',
    method: 'GET',
    params: data,
  })
}
// 全部订单 重新修改弹窗 回显
export const getOrderUpdateInfo = (data: any): any => {
  return request({
    url: 'zqcrm/order/getOrderUpdateInfo',
    method: 'GET',
    params: data,
  })
}
// 全部订单 重新修改弹窗 提交
export const orderUpdate = (data: any): any => {
  return request({
    url: 'zqcrm/order/updateOrder',
    method: 'POST',
    data,
  })
}
// 全部订单 拆分支付接口
export const orderSplit = (id: any): any => {
  return request({
    url: `zqcrm/order/split/${id}`,
    method: 'put',
  })
}
// 全部订单 修改 修改类型下拉框
export const getOrderModifyType = (data: any): any => {
  return request({
    url: 'zqcrm/order/getOrderModifyType',
    method: 'GET',
    params: data,
  })
}
// 全部订单 修改 回显数据
export const getOrderModifyInfo = (data: any): any => {
  return request({
    url: 'zqcrm/order/getOrderModifyInfo',
    method: 'POST',
    data,
  })
}
// 全部订单 修改提交接口
export const orderModify = (data: any): any => {
  return request({
    url: 'zqcrm/order/modifyOrder',
    method: 'POST',
    data,
  })
}
// 全部订单 修改案件信息
export const modifyCase = (data: any): any => {
  return request({
    url: 'zqcrm/order/modifyCase',
    method: 'POST',
    data,
  })
}
// 全部订单 上传合同
export const uploadContractApi = (data: any): any => {
  return request({
    url: 'zqcrm/order/uploadContract',
    method: 'POST',
    data,
  })
}
// 订单审批 审批弹窗 回显数据
export const orderExamineDetail = (data: any): any => {
  return request({
    url: 'zqcrm/orderExamine/orderExamineDetail',
    method: 'GET',
    params: data,
  })
}
// 回款审批 到处接口
export const paybackApprovalExport = (data: any): any => {
  return request({
    url: 'zqcrm/examine/cash_examine/export',
    method: 'post',
    data,
    // 指定请求类型为二进制流
    // 不写可能会造成下载成功的图片和文件是看不到和没有内容的
    responseType: 'blob',
  })
}
// 成本管理 列表接口
export const getProductCostPage = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/getProductCostPage',
    method: 'POST',
    data,
  })
}
// 成本清单 获取产品列表
export const getCostProductList = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/getProduct',
    method: 'GET',
    params: data,
  })
}
// 成本清单 获取供应商列表
export const getProviderList = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/getProviderList',
    method: 'GET',
    params: data,
  })
}
// 成本清单 详情接口
export const getCostDetail = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/detail',
    method: 'GET',
    params: data,
  })
}
// 成本清单 新增供应商
export const addProvider = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/addSupplier',
    method: 'POST',
    data,
  })
}
// 成本清单 新增供应商
export const addProvider1 = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/addProvider',
    method: 'POST',
    data,
  })
}
// 成本清单 编辑供应商
export const updateProvider1 = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/updateProvider',
    method: 'POST',
    data,
  })
}
// 待收款 预计回款时间修改
export const orderPayInfoTime = (data: any): any => {
  return request({
    url: 'zqcrm/orderPayInfo/updateMaybePayTime',
    method: 'POST',
    data,
  })
}
// 供应商管理 列表接口
export const getProviderPage = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/getProviderPage',
    method: 'POST',
    data,
  })
}

// 供应商管理 存续供应商
export const surviveSupplier = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/surviveSupplier',
    method: 'POST',
    data,
  })
}

// 供应商管理 根据id编辑供应商是否激活
export const switchEnable = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/switchEnable',
    method: 'POST',
    data,
  })
}

// 供应商管理 列表导出接口
export const exportSupplierList = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/exportSupplierList',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

// 查询即将到期的供应商数量
export const overdueSupplierCount = (): any => {
  return request({
    url: 'zqcrm/product/provider/overdueSupplierCount',
    method: 'GET',
  })
}

// 工单检索 列表接口
export const getAllWorkList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAllWorkList',
    method: 'POST',
    data,
  })
}
// 工单检索 筛选条件
export const getAllWorkStatusList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAllWorkStatusList',
    method: 'GET',
    params: data,
  })
}
// 成本清单  编辑操作
export const editCost = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/addProductCost',
    method: 'POST',
    data,
  })
}
// 成本管理 删除
export const deleteCost = (ids: Number): any => {
  return request({
    url: 'zqcrm/product/cost/deleteProductCost',
    method: 'DELETE',
    params: ids,
  })
}
// 供应商管理 删除
export const deleteProvider = (ids: Number): any => {
  return request({
    url: 'zqcrm/product/provider/deleteProvider',
    method: 'DELETE',
    params: ids,
  })
}
// 供应商管理 详情
export const getProviderDetail = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/getProviderDetail',
    method: 'GET',
    params: data,
  })
}
// 工单管理 工单池列表数据
export const getWorkPoolList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getWorkPoolList',
    method: 'POST',
    data,
  })
}
// 工单管理 待接收
export const getToBeReceivedList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getToBeReceivedList',
    method: 'POST',
    data,
  })
}
// 工单管理 受理中 /已办结 已完结  / 暂停
export const getAcceptingList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAcceptingList',
    method: 'POST',
    data,
  })
}
// 审批管理 退款审批列表
export const getRefundList = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/getRefundList',
    method: 'POST',
    data,
  })
}
// 添加成本 选择成本 成本下拉框
export const getCostList = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/getCostList',
    method: 'GET',
    params: data,
  })
}
// 工单池 批量领取
export const getReceivedWorkList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getSameTypeWorkList',
    method: 'POST',
    data,
  })
}
// 工单池 确认领取
export const receiveWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/receiveWork',
    method: 'POST',
    data,
  })
}
// 查询服务顾问列表
export const getConsultantUserList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getConsultantUserList',
    method: 'GET',
    params:data,
  })
}
// 查询服务会计列表
export const getAccountantUserList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAccountantUserList',
    method: 'GET',
    params:data,
  })
}
// 转交工单（财税线）
export const transferFiscalWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/transferFiscalWork',
    method: 'POST',
    data,
  })
}
// 分配顾问
export const allocateConsultant = (data: any): any => {
  return request({
    url: 'zqcrm/work/allocateConsultant',
    method: 'POST',
    data,
  })
}
// 分配会计
export const allocateAccountant = (data: any): any => {
  return request({
    url: 'zqcrm/work/allocateAccountant',
    method: 'POST',
    data,
  })
}
// 服务顾问派单
export const consultantDispatch = (data: any): any => {
  return request({
    url: 'zqcrm/work/consultantDispatch',
    method: 'GET',
    params:data,
  })
}
// 退回工单池
export const returnWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/returnWork',
    method: 'GET',
    params:data,
  })
}
// 详情页面 工单详情
export const getWorkInfo = (data: any): any => {
  return request({
    url: 'zqcrm/work/getWorkInfo',
    method: 'GET',
    params: data,
  })
}
// 退款审批 弹窗 选择客户下拉框接口
export const refundCustomers = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/refundCustomers',
    method: 'GET',
    params: data,
  })
}
// 工单 上传附件提交接口
export const uploadFile = (data: any): any => {
  return request({
    url: 'zqcrm/work/uploadFile',
    method: 'POST',
    data,
  })
}
// 退款审批 弹窗选择账单接口
export const refundItems = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/refundItems',
    method: 'POST',
    data,
  })
}
// 工单 新增成本 提交接口
export const addCostApi = (data: any): any => {
  return request({
    url: 'zqcrm/work/addCost',
    method: 'POST',
    data,
  })
}
// 工单池 接收对象下拉列表
export const getReceiverList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getReceiverList',
    method: 'POST',
    data,
  })
}
// 工单池 接收对象下拉列表
export const getReceiverListV1 = (data: any): any => {
  return request({
    url: 'zqcrm/work/getReceiverListV1',
    method: 'POST',
    data,
  })
}
// 工单池 分配工单
export const allocateWorkApiV1 = (data: any): any => {
  return request({
    url: 'zqcrm/work/allocateWorkV1',
    method: 'POST',
    data,
  })
}
// 工单池 分配工单
export const allocateWorkApi = (data: any): any => {
  return request({
    url: 'zqcrm/work/allocateWork',
    method: 'POST',
    data,
  })
}
// 供应商管理 编辑
export const updateProvider = (data: any): any => {
  return request({
    url: 'zqcrm/product/provider/updateProvider',
    method: 'POST',
    data,
  })
}
// 工单管理 受理中 已完结 已办结 列表
export const getAcceptingListApi = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAcceptingList',
    method: 'POST',
    data,
  })
}
// 工单管理待接收页面 接受操作
export const confirmReceiveWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/confirmReceiveWork',
    method: 'POST',
    data,
  })
}
// 办结工单弹窗确认
export const finishWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/finishWork',
    method: 'POST',
    data,
  })
}
// 停滞工单 弹窗确认
export const stagnantWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/stagnantWork',
    method: 'POST',
    data,
  })
}
// 终止工单 弹窗确认
export const terminateWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/terminateWork',
    method: 'POST',
    data,
  })
}
// 审核终止工单 弹窗详情数据
export const getWorkExamineInfo = (data: any): any => {
  return request({
    url: 'zqcrm/work/getWorkExamineInfo',
    method: 'GET',
    params: data,
  })
}
// 审核弹窗 工单审核确定按钮
export const reviewWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/reviewWork',
    method: 'POST',
    data,
  })
}
// 完结工单 确定按钮
export const endWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/endWork',
    method: 'GET',
    params: data,
  })
}
// 完结工单 成本列表
export const getWorkCostList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getWorkCostList',
    method: 'GET',
    params: data,
  })
}
// 恢复工单 确定按钮
export const restoreWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/restoreWork',
    method: 'POST',
    data,
  })
}
// 供应商付款列表接口
export const querySupplierExamineList = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/querySupplierExamineList',
    method: 'POST',
    data,
  })
}
// 供应商付款 选择供应商列表接口
export const getSupplierList = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/getSupplierList',
    method: 'GET',
    params: data,
  })
}
// 供应商付款 发起审批
export const addSupplierExamine = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/addSupplierExamine',
    method: 'POST',
    data,
  })
}
// 供应商付款 选择成本表格接口
export const getSupplierWorkList = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/getSupplierWorkList',
    method: 'GET',
    params: data,
  })
}
// 供应商付款 撤回审批
export const withdrawExamine = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/withdrawExamine',
    method: 'GET',
    params: data,
  })
}
// 工单 转交工单
export const transferWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/transferWork',
    method: 'POST',
    data,
  })
}
// 供应商付款 详情接口
export const supplierExamineDetail = (data: any): any => {
  return request({
    url: 'zqcrm/supplierExamine/supplierExamineDetail',
    method: 'GET',
    params: data,
  })
}
// 产品管理 业务产品 新增产品接口
export const addProduct = (data: any): any => {
  return request({
    // url: 'zqcrm/product/product/addOrUpdateProduct',
    url: 'zqcrm/product/product/addProduct',
    method: 'POST',
    data,
  })
}
// 产品管理 业务产品 查询主产品
export const getMainProducts = (data?: any): any => {
  return request({
    url: 'zqcrm/product/product/getMainProducts',
    method: 'GET',
  })
}

// 产品管理 业务产品 下架主产品时列出所有子产品
export const getSubProductList = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/getSubProductList',
    method: 'GET',
    params: data,
  })
}
// 产品管理 业务产品 下架产品
export const offProduct = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/offProduct',
    method: 'POST',
    data,
  })
}
// 产品管理 业务产品 变更产品
export const changeProduct = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/changeProduct',
    method: 'POST',
    data,
  })
}
// 赠送购物卡
export const queryShopcardExamineList = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/queryShopcardExamineList',
    method: 'POST',
    data,
  })
}
// 赠送购物卡 选择客户 下拉列表
export const getCustomerList = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/getCustomerList',
    method: 'GET',
    params: data,
  })
}
// 赠送购物卡 获取工单列表 表格数据
export const getWorkList = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/getWorkList',
    method: 'GET',
    params: data,
  })
}
// 赠送购物卡 发起审批 提交接口
export const addshopcardExamine = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/addshopcardExamine',
    method: 'POST',
    data,
  })
}
// 赠送购物卡 撤回审批
export const withdrawExamine1 = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/withdrawExamine',
    method: 'GET',
    params: data,
  })
}
// 业务产品 选择产品列表接口
export const getProductCostList = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/getProductCostList',
    method: 'POST',
    data,
  })
}
// 成本清单 编辑接口
export const updateProductCost = (data: any): any => {
  return request({
    url: 'zqcrm/product/cost/updateProductCost',
    method: 'POST',
    data,
  })
}
// 赠送购物卡 详情接口
export const shopcardExamineDetail = (data: any): any => {
  return request({
    url: 'zqcrm/shopcardExamine/shopcardExamineDetail',
    method: 'GET',
    params: data,
  })
}
// 退款审批 撤回申请
export const cancelApproval = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/cancelApproval',
    method: 'POST',
    data,
  })
}
// 退款审批 详情
export const refundDetail = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/refundDetail',
    method: 'GET',
    params: data,
  })
}
// 返佣审批 列表
export const getReBateList = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/getReBateList',
    method: 'POST',
    data,
  })
}
// 返佣客户
export const rebateCustomers = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/rebateCustomers',
    method: 'GET',
    params: data,
  })
}
// 返佣 发起审批
export const doReBate = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/doReBate',
    method: 'POST',
    data,
  })
}
// 返佣 工单项
export const rebateItems = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/rebateItems',
    method: 'POST',
    data,
  })
}
// 退款审批 发起审批
export const refundDoRefund = (data: any): any => {
  return request({
    url: 'zqcrm/refundExamine/doRefund',
    method: 'POST',
    data,
  })
}
// 返佣审批 撤回接口
export const cancelApproval1 = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/cancelApproval',
    method: 'POST',
    data,
  })
}
// 返佣审批 详情接口
export const rebateDetail = (data: any): any => {
  return request({
    url: 'zqcrm/rebateExamine/rebateDetail',
    method: 'GET',
    params: data,
  })
}
// 受理中 服务中列表 纳税人资质修改
export const updateTaxpayer = (data: any): any => {
  return request({
    url: 'zqcrm/work/updateSubstitutionTag',
    method: 'POST',
    data,
  })
}
// 客户分发 获取列表数据
export const customerRecommendPage = (data: any): any => {
  return request({
    url: 'zqcrm/customer/customerRecommendPage',
    method: 'POST',
    data,
  })
}
// 客户分发 分配对象下拉数据
export const getAllocationObjectList = (data: any): any => {
  return request({
    url: 'zqcrm/customer/getAllocationObjectList',
    method: 'GET',
    params: data,
  })
}
// 客户分发 分配客户提交接口
export const allocationCustomer = (data: any): any => {
  return request({
    url: 'zqcrm/customer/allocationCustomer',
    method: 'POST',
    data,
  })
}
// 客户分发 客户分发导出
export const exportCustomerRecommend = (data: any): any => {
  return request({
    url: 'zqcrm/customer/exportCustomerRecommend',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}
// 催收管理 待催收页面列表
export const getPendingRenewPage = (data: any): any => {
  return request({
    url: 'zqcrm/work/getPendingRenewPage',
    method: 'POST',
    data,
  })
}
// 催收管理 待催收 快捷充值
export const fastPay = (data: any): any => {
  return request({
    url: 'zqcrm/work/fastPay',
    method: 'POST',
    data,
  })
}
// 待催收 批量退户
export const batchToPendingCheckOut = (data: any): any => {
  return request({
    url: 'zqcrm/work/batchToPendingCheckOut',
    method: 'POST',
    data,
  })
}
// 待催收 快捷支付-二维码弹窗接口
export const fastPayQRCode = (data: any): any => {
  return request({
    url: 'zqcrm/work/fastPayQRCode',
    method: 'GET',
    params: data,
  })
}
// 待催收 获取所属客户是否有其他工单
export const otherServicingWork = (data: any): any => {
  return request({
    url: 'zqcrm/work/otherServicingWork',
    method: 'POST',
    data,
  })
}
// 催收管理 根据业务线ID查询周期性的产品
export const getCycleProductList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getCycleProductList',
    method: 'GET',
    params: data,
  })
}
// 催收管理 查询周期性的子产品
export const getCycleSubProductList = (data: any): any => {
  return request({
    url: 'zqcrm/work/getCycleSubProductList',
    method: 'GET',
    params: data,
  })
}
// 催收管理 查询已发签的的订单信息
export const collectGetOrderInfo = (data: any): any => {
  return request({
    url: 'zqcrm/work/getOrderInfo',
    method: 'GET',
    params: data,
  })
}
// 修改服务时间
export const updateServiceDate = (data: any): any => {
  return request({
    url: 'zqcrm/work/updateServiceDate',
    method: 'POST',
    data
  })
}
// 正企商城 产品分类
export const getProductCategoryList = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodCategory/list',
    method: 'POST',
    data,
  })
}
// 正企商城 产品分类不分页
export const getProductCategoryListNoPage = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodCategory/categoryList',
    method: 'GET',
    params: data,
  })
}

// 正企商城 产品分类详情
export const queryGoodCategoryDetail = (data: any): any => {
  return request({
    url: `zqcrm/admin/goodCategory/${data.id}`,
    method: 'GET',
    params: data,
  })
}

// 正企商城 新增产品分类
export const addGoodCategory = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodCategory/addGoodCategory',
    method: 'POST',
    data,
  })
}

// 正企商城 编辑产品分类
export const editGoodCategory = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodCategory/editGoodCategory',
    method: 'POST',
    data,
  })
}

// 正企商城 商品列表
export const getShopProductList = (data: any): any => {
  return request({
    url: 'zqcrm/good/list',
    method: 'POST',
    data,
  })
}
// 正企商城 商城订单
export const getOrderList = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodOrder/getGoodOrderList',
    method: 'POST',
    data,
  })
}
// 正企商品 待分配列表
export const getToBeAssigned = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodOrder/getToBeAssigned',
    method: 'POST',
    data,
  })
}
// 正企商城 分配订单
export const assignOrder = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodOrder/assignOrder',
    method: 'POST',
    data,
  })
}
// 正企商品 待分配删除接口
export const deleteOrderShop = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodOrder/remove',
    method: 'GET',
    params: data,
  })
}
// 正企商城 产品分类删除
export const goodCategoryClassify = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodCategory',
    method: 'DELETE',
    params: data,
  })
}
// 正企商城 商品列表删除
export const goodCategoryList = (data: any): any => {
  return request({
    url: 'zqcrm/good',
    method: 'DELETE',
    params: data,
  })
}
// 工单分发规则 列表
export const workRulePageexport = (data: any): any => {
  return request({
    url: 'zqcrm/customer/workRulePage',
    method: 'POST',
    data,
  })
}
// 工单分配规则 岗位配额
export const postQuotaPage = (data: any): any => {
  return request({
    url: 'zqcrm/customer/postQuotaPage',
    method: 'POST',
    data,
  })
}
// 工单分发规则 编辑岗位配额
export const editPostQuota = (data: any): any => {
  return request({
    url: 'zqcrm/customer/editPostQuota',
    method: 'POST',
    data,
  })
}
// 工单分发规则 指定人员
export const getRuleUserList = (data: any): any => {
  return request({
    url: 'zqcrm/customer/getRuleUserList',
    method: 'GET',
    params: data,
  })
}
// 工单分发规则 新增规则
export const addWorkRule = (data: any): any => {
  return request({
    url: 'zqcrm/customer/addWorkRule',
    method: 'POST',
    data,
  })
}
// 工单分发规则 编辑规则
export const editWorkRule = (data: any): any => {
  return request({
    url: 'zqcrm/customer/editWorkRule',
    method: 'POST',
    data,
  })
}
// 分发管理 客户分发规则 列表数据
export const customerRulePage = (data: any): any => {
  return request({
    url: 'zqcrm/customer/customerRulePage',
    method: 'POST',
    data,
  })
}
// 分发管理 分配人员列表 下拉数据
export const getRuleUserListA = (data: any): any => {
  return request({
    url: 'system/user/list',
    method: 'GET',
    params: data,
  })
}
// 分发管理 客户分发规则 新增规则
export const addCustomerRule = (data: any): any => {
  return request({
    url: 'zqcrm/customer/addCustomerRule',
    method: 'POST',
    data,
  })
}
// 分发管理 客户分发规则 编辑
export const editCustomerRule = (data: any): any => {
  return request({
    url: 'zqcrm/customer/editCustomerRule',
    method: 'POST',
    data,
  })
}
// 企查查列表数据
export const qiChaChaGetList = (data: any): any => {
  return request({
    url: 'zqcrm/customer/qiChaChaGetList',
    method: 'GET',
    params: data,
  })
}
// 企查查确定覆盖公司接口
export const qiChaChaConfirm = (data: any): any => {
  return request({
    url: 'zqcrm/customerStatusTag/updateCustomerByQcc',
    method: 'POST',
    data,
  })
}
// 发起签约第四步回第三步 补充协议回显接口
export const previewAgreement = (data: any): any => {
  return request({
    url: 'zqcrm/order/previewAgreement',
    method: 'GET',
    params: data,
  })
}
// 工单分发规则
export const getWorkRuleUsers = (data: any): any => {
  return request({
    url: 'zqcrm/customer/getWorkRuleUsers',
    method: 'GET',
    params: data,
  })
}
// 根据业务线 获取业务产品
export const getProductByTagId = (data: any): any => {
  return request({
    url: 'zqcrm/customer/getProductByTagId',
    method: 'GET',
    params: data,
  })
}
// 客户详情页 工单记录列表
export const getWorkPage = (data: any): any => {
  return request({
    url: 'zqcrm/work/getWorkPage',
    method: 'POST',
    data,
  })
}
// 订单限制开关 设置赠送上限
export const getCycleProductListPost = (data: any): any => {
  // 查询周期性产品列表
  return request({
    url: 'zqcrm/switchSet/getCycleProductList',
    method: 'GET',
    params: data,
  })
}
// 订单限制开关 新增赠送月份规则
export const insertCycleSetRule = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/insertCycleSetRule ',
    method: 'POST',
    data,
  })
}
// 订单限制开关 查询/回显赠送月份规则
export const queryCycleSetRuleList = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/queryCycleSetRuleList',
    method: 'GET',
    params: data,
  })
}
// 订单限制开关 配置主产品
export const getParentProductList = (data: any): any => {
  return request({
    url: 'zqcrm/switchSet/getParentProductList',
    method: 'POST',
    data,
  })
}
// 全部订单 退款操作
export const refundOrder = (data: any): any => {
  return request({
    url: 'zqcrm/order/refund',
    method: 'POST',
    data,
  })
}
// 待催收
export const getAddressAdmin = (data: any): any => {
  return request({
    url: 'zqcrm/work/getAddressAdmin',
    method: 'GET',
    params: data,
  })
}

// 是否是当前登陆人
export const getisOnlyAddressAdmin = (data: any): any => {
  return request({
    url: 'zqcrm/work/isOnlyAddressAdmin',
    method: 'GET',
    params: data,
  })
}

// 待催收
export const queryAddressProductList = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/queryAddressProductList',
    method: 'GET',
    params: data,
  })
}
// 待催收 - 发起签约 第一步到第二步
export const addOrderRush = (data: any): any => {
  return request({
    url: 'zqcrm/order/addOrderRush',
    method: 'POST',
    data,
  })
}
// 待催收 - 发起签约 第一步到第二步 校验
export const verifyOrderRush = (data: any): any => {
  return request({
    url: 'zqcrm/order/verifyOrderRush',
    method: 'POST',
    data,
  })
}
// 正企商城 待分配订单 接收对象接口
export const getReceivingPerson = (data: any): any => {
  return request({
    url: 'zqcrm/admin/goodOrder/getReceivingPerson',
    method: 'GET',
    params: data,
  })
}

export const customerRepeatCheckPage = (data: any): any => {
  return request({
    url: 'zqcrm/customer/customerRepeatCheckPage',
    method: 'POST',
    data,
  })
}

export const checkCustomerId = (data: any): any => {
  return request({
    url: 'zqcrm/customer/checkCustomerId',
    method: 'GET',
    params: data,
  })
}

export const customerRepeatHandle = (data: any): any => {
  return request({
    url: 'zqcrm/customer/customerRepeatHandle',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询活动设置列表
 * @param {any} data
 * @return {*}
 */
export const getGiftRulesList = (data: any): any => {
  return request({
    url: 'zqcrm/giftRules/getGiftRulesList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 活动设置状态变更
 * @return {*}
 */
export const updateGiftRulesStatus = (data: any): any => {
  return request({
    url: 'zqcrm/giftRules/updateStatus',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 查询购物卡列表
 * @return {*}
 */
export const queryCrmCardList = (data: any): any => {
  return request({
    url: 'zqcrm/crmCard/queryCrmCardList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询购物卡消费记录
 * @return {*}
 */
export const queryCrmDetailById = (data: any): any => {
  return request({
    url: 'zqcrm/crmCard/queryCrmDetailById',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 查询客户商场卡、正企卡余额
 * @return {*}
 */
export const queryCrmBalanceByTelephone = (data: any): any => {
  return request({
    url: 'zqcrm/crmCard/queryCrmBalanceByTelephone',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 转账
 * @return {*}
 */
export const transferCrmCard = (data: any): any => {
  return request({
    url: 'zqcrm/crmCard/transferCrmCard',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询商品标签列表
 * @return {*}
 */
export const queryGoodTagList = (data: any): any => {
  return request({
    url: 'zqcrm/goodTag/list',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 新增组合商品
 * @return {*}
 */
export const addCombGoods = (data: any): any => {
  return request({
    url: 'zqcrm/good/addGood',
    method: 'POST',
    data,
  })
}

/**
 * @description: 编辑组合商品
 * @return {*}
 */
export const editCombGoods = (data: any): any => {
  return request({
    url: 'zqcrm/good/editGood',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询组合商品列表
 * @return {*}
 */
export const queryGoodsList = (data: any): any => {
  return request({
    url: 'zqcrm/good/list',
    method: 'POST',
    data,
  })
}

/**
 * @description: 删除组合商品
 * @return {*}
 */
export const deleteGoodsById = (data: any): any => {
  return request({
    url: 'zqcrm/good/remove',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 查询组合商品详情
 * @return {*}
 */
export const queryComGoodsDetail = (data: any): any => {
  return request({
    url: `zqcrm/good/${data.id}`,
    method: 'GET',
    data,
  })
}

// 业务产品 选择产品列表接口
export const queryProduct = (data: any): any => {
  // 业务产品 获取分页
  return request({
    url: 'zqcrm/product/product/getProduct',
    method: 'GET',
    data,
  })
}

// 查询抵扣券列表
export const queryDeductionCouponList = (data: any): any => {
  return request({
    url: 'zqcrm/deductionCoupon/queryDeductionCouponList',
    method: 'POST',
    data,
  })
}

// 查询抵扣券消费记录
export const queryDeductionDetail = (data: any): any => {
  return request({
    url: 'zqcrm/deductionCoupon/queryDeductionDetail',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 修改商品上下架状态
 * @return {*}
 */
export const batchUpDown = (data: any): any => {
  return request({
    url: 'zqcrm/good/batchUpDown',
    method: 'POST',
    data,
  })
}

/**
 * @description: 导出工单数据
 * @return {*}
 */
export const exportWorkList = (data: any): any => {
  return request({
    url: 'zqcrm/work/exportWorkList',
    method: 'POST',
    data,
    // 指定请求类型为二进制流
    // 不写可能会造成下载成功的图片和文件是看不到和没有内容的
    responseType: 'blob',
  })
}

/**
 * @description: 导出订单数据
 * @return {*}
 */
export const exportOrderList = (data: any): any => {
  return request({
    url: 'zqcrm/order/exportOrderList',
    method: 'POST',
    data,
    // 指定请求类型为二进制流
    // 不写可能会造成下载成功的图片和文件是看不到和没有内容的
    responseType: 'blob',
  })
}

/**
 * @description: 产品大类分类饼状图
 * @return {*}
 */
export const getTagAmount = (data: any): any => {
  return request({
    url: 'zqcrm/dashboards/getTagAmount',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务总计收入统计
 * @return {*}
 */
export const getDashboardsIncome = (data?: any): any => {
  return new Promise((resolve) => {
    request({
      url: 'zqcrm/dashboards/getDashboardsIncome',
      method: 'GET',
      params: data,
    }).then((res: any) => {
      if (res.code === 200) {
        const array = [
          { name: '业务总计收入', value: res.data.revenueTotal, proportion: { revenueYoy: res.data.revenueYoy, revenueMom: res.data.revenueMom }, symbol: '¥' },
          { name: '订单业务总量', value: res.data.businessTotal, proportion: { revenueYoy: res.data.businessYoy, revenueMom: res.data.businessMom } },
          { name: '执行工单总量', value: res.data.workOrdersTotal, proportion: { revenueYoy: res.data.workOrdersYoy, revenueMom: res.data.workOrdersMom } },
          { name: '已回金额', value: res.data.paidAmount, symbol: '¥' },
          { name: '待跟进客户', value: res.data.followedCustomerTotal },
          { name: '昨日总收入', value: res.data.yesterdayRevenueTotal, symbol: '¥' },
          { name: '昨日订单业务', value: res.data.yesterdayBusinessTotal },
          { name: '昨日执行工单', value: res.data.yesterdayWorkOrdersTotal },
          { name: '未回金额', value: res.data.unpaidAmount, symbol: '¥' },
          { name: '昨日跟进客户', value: res.data.yesterdayFollowedCustomerTotal },
        ]
        resolve(array)
      }
    })
  })
}

/**
 * @description: 执行工单分类饼状图
 * @return {*}
 */
export const getWorkStatusDistribution = (data: any): any => {
  return request({
    url: 'zqcrm/dashboards/getWorkStatusDistribution',
    method: 'POST',
    data,
  })
}

/**
 * @description: 总收入排名
 * @return {*}
 */
export const getIncomeRank = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getIncomeRank',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 业务总收入折线图
 * @return {*}
 */
export const getRevenueLineChart = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getRevenueLineChart',
    method: 'POST',
    data,
  })
}

/**
 * @description: 订单业务量折现图
 * @return {*}
 */
export const getOrderLineChart = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getOrderLineChart',
    method: 'POST',
    data,
  })
}

/**
 * @description: 执行工单数折线图
 * @return {*}
 */
export const queryWorkLineChart = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getWorkLineChart',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询部门列表
 * @return {*}
 */
export const getDeptList = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getDeptList',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 获取团队总览列表
 * @return {*}
 */
export const getTeamData = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getTeamData',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务总收入（按人）
 * @return {*}
 */
export const getAllIncomeByUser = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getAllIncomeByUser',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务总量（按人）
 * @return {*}
 */
export const getOrderTotalByUser = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getOrderTotalByUser',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务单产（按人）
 * @return {*}
 */
export const getWorkTotalByUser = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getWorkTotalByUser',
    method: 'POST',
    data,
  })
}

/**
 * @description: 跟进客户总览
 * @return {*}
 */
export const getFollowCustomersData = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getFollowCustomersData',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务总收入（按业务线）
 * @return {*}
 */
export const getAllIncomeByProduct = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getAllIncomeByProduct',
    method: 'POST',
    data,
  })
}

/**
 * @description: 订单业务总量（按业务线）
 * @return {*}
 */
export const getOrderTotalByProduct = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getOrderTotalByProduct',
    method: 'POST',
    data,
  })
}

/**
 * @description: 业务总收入（按渠道）
 * @return {*}
 */
export const getAllIncomeByChannel = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getAllIncomeByChannel',
    method: 'POST',
    data,
  })
}

/**
 * @description: 订单业务总量（按渠道）
 * @return {*}
 */
export const getOrderTotalByChannel = (data?: any): any => {
  return request({
    url: 'zqcrm/dashboards/getOrderTotalByChannel',
    method: 'POST',
    data,
  })
}


/**
 * @description: 获取人员绑定数据列表
 * @return {*}
 */
export const getPersonBindList = (data?: any): any => {
  return request({
    url: 'zqcrm/personBind/getPersonBindList',
    method: 'POST',
    data,
  })
}


/**
 * @description: 查询会计、顾问人员列表
 * @return {*}
 */
export const getTaxDepIdUserList = (data?: any): any => {
  return request({
    url: 'zqcrm/personBind/getTaxDepIdUserList',
    method: 'GET',
    params: data,
  })
}


/**
 * @description: 添加人员绑定规则
 * @return {*}
 */
export const addPersonBind = (data?: any): any => {
  return request({
    url: 'zqcrm/personBind/addPersonBind',
    method: 'POST',
    data,
  })
}


/**
 * @description: 编辑人员绑定规则
 * @return {*}
 */
export const updatePersonBind = (data?: any): any => {
  return request({
    url: 'zqcrm/personBind/updatePersonBind',
    method: 'POST',
    data,
  })
}


/**
 * @description: 添加人员绑定规则
 * @return {*}
 */
export const updateRelyAddress = (data?: any): any => {
  return request({
    url: 'zqcrm/work/updateRelyAddress',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 查询拜访计划列表
 * @return {*}
 */
export const getVisitPlanList = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/queryVisitPlanList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 取消关联拜访计划
 * @return {*}
 */
export const delRelation = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/delRelation',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询关联/撤销拜访计划列表
 * @return {*}
 */
export const getRelationPlanList = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/queryRelationPlanList',
    method: 'POST',
    data,
  })
}


/**
 * @description: 添加拜访计划
 * @return {*}
 */
// export const addVisitPlan = (data?: any): any => {
//   return request({
//     url: 'zqcrm/visitPlan/addVisitPlan',
//     method: 'POST',
//     data,
//   })
// }

/**
 * @description: 添加拜访计划备注
 * @return {*}
 */
export const addRemarkById = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/addRemarkById',
    method: 'POST',
    data,
  })
}

/**
 * @description: 删除拜访计划
 * @return {*}
 */
// export const deleteVisitPlan = (data?: any): any => {
//   return request({
//     url: 'zqcrm/visitPlan/deleteVisitPlan',
//     method: 'GET',
//     params: data,
//   })
// }

/**
 * @description: 拜访客户名称
 * @return {*}
 */
// export const queryCustomerList = (data?: any): any => {
//   return request({
//     url: 'zqcrm/visitPlan/queryCustomerList',
//     method: 'GET',
//     params: data,
//   })
// }

/**
 * @description: 导出拜访计划
 * @return {*}
 */
export const exportVisitPlanList = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/exportVisitPlanList',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 拜访管理 - 拜访计划 - 申请礼品
 * @return {*}
 */
export const requestGift = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/requestGift',
    method: 'POST',
    data,
  })
}

/**
 * @description: 上传录音
 * @return {*}
 */
export const addCallFile = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/addCallFile',
    method: 'POST',
    data,
  })
}

/**
 * @description: 添加协同人
 * @return {*}
 */
export const addCollaborator = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/addCollaborator',
    method: 'POST',
    data,
  })
}

/**
 * @description: 删除协同人
 * @return {*}
 */
export const deleteCollaborator = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/deleteCollaborator',
    method: 'POST',
    data,
  })
}

/**
 * @description: 添加拜访计划关联
 * @return {*}
 */
export const addRelation = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/addRelation',
    method: 'POST',
    data,
  })
}

/**
 * @description: 取消拜访计划
 * @return {*}
 */
export const cancelVisitPlan = (data?: any): any => {
  return request({
    url: 'zqcrm/visitPlan/cancelVisitPlan',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 查询拜访计划撤销审批列表
 * @return {*}
 */
export const queryVisitCancelExamineList = (data?: any): any => {
  return request({
    url: 'zqcrm/visitCancelExamine/queryVisitCancelExamineList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 拜访计划撤销审批
 * @return {*}
 */
export const processExamine = (data?: any): any => {
  return request({
    url: 'zqcrm/visitCancelExamine/processExamine',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询业绩目标(部门)列表
 * @return {*}
 */
export const queryPerformanceTargetList = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPerformanceTargetList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询促销目标(部门)列表
 * @return {*}
 */
export const queryPromotionTargetList = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPromotionTargetList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询新增客户目标(部门)列表
 * @return {*}
 */
export const queryCustomerTargetList = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryCustomerTargetList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询业绩目标(部门)排行榜
 * @return {*}
 */
export const queryPerformanceDeptRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPerformanceDeptRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询促销目标(部门)排行榜
 * @return {*}
 */
export const queryPromotionDeptRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPromotionDeptRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询新增客户目标(部门)排行榜
 * @return {*}
 */
export const queryCustomerDeptRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryCustomerDeptRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询业绩目标(个人)排行榜
 * @return {*}
 */
export const queryPerformanceUserRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPerformanceUserRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询促销目标(部门)排行榜
 * @return {*}
 */
export const queryPromotionUserRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryPromotionUserRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询新增客户目标(部门)排行榜
 * @return {*}
 */
export const queryCustomerUserRank = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryCustomerUserRank',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询业绩目标看板列表
 * @return {*}
 */
export const queryTargetKanbanList = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryTargetKanbanList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询正企事业群下的部门及用户
 * @return {*}
 */
export const queryDeptUserList = (data?: any): any => {
  return request({
    url: 'zqcrm/performance/queryDeptUserList',
    method: 'GET',
  })
}

/**
 * @description: 客户分析-客户管理阶段分布
 * @return {*}
 */
export const customerStage = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/customerStage',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析-客户管理数量
 * @return {*}
 */
export const customerCount = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/customerCount',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析-新增客户折线图
 * @return {*}
 */
export const customerNew = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/customerNew',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-拜访签到报表
 * @return {*}
 */
export const getVisitStatistics = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPractices/getVisitStatistics',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-外呼记录报表
 * @return {*}
 */
export const getCallStatistics = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPractices/getCallStatistics',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-跟进阶段分析
 * @return {*}
 */
export const getCustomerAnalytics = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPractices/getCustomerAnalytics',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-跟进行为分析
 * @return {*}
 */
export const getCustomerFollowUp = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPractices/getCustomerFollowUp',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-销售行为
 * @return {*}
 */
export const getSalesBehavior = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/salesBehavior',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-业务类别分布(部门)
 * @return {*}
 */
export const getBusinessCategoryByDept = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/businessCategoryByDept',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-业务类别分布(个人)
 * @return {*}
 */
export const getBusinessCategoryByPerson = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/businessCategoryByPerson',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-业务类别分布(个人)
 * @return {*}
 */
export const getProductSales = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productSales',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-产品单量
 * @return {*}
 */
export const getProductOrderCount = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productOrderCount',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-产品单量(个人)
 * @return {*}
 */
export const getProductOrderCountByPerson = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productOrderCountByPerson',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-产品单产
 * @return {*}
 */
export const getProductOrderAmount = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productOrderAmount',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-产品单产(团队总览)
 * @return {*}
 */
export const getProductSalesByDept = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productSalesByDept',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析看板-潜在客户分析（部门）
 * @return {*}
 */
export const getPotentialCustomerByDept = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/potentialCustomerByDept',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析看板-潜在客户分析（个人）
 * @return {*}
 */
export const getPotentialCustomerByPerson = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/potentialCustomerByPerson',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析看板-客户渠道分析
 * @return {*}
 */
export const getCustomerChannel = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/analyze/customerChannel',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售看板-产品销售查看
 * @return {*}
 */
export const getProductSalesByUser = (data?: any): any => {
  return request({
    url: 'zqcrm/product/sales/productSalesByUser',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 产品变更通知
 * @return {*}
 */
export const queryProductChangeInfo = (data?: any): any => {
  return request({
    url: 'zqcrm/product/product/queryProductChangeInfo',
    method: 'GET'
  })
}

/**
 * @description: 产品变更通知已知晓
 * @return {*}
 */
export const readChangeNotice = (data: any): any => {
  return request({
    url: 'zqcrm/product/product/readChangeNotice',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 目标设置 - 查询部门组织架构
 * @return {*}
 */
export const getDeptListForGoal = (): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/getDeptList',
    method: 'GET',
  })
}

/**
 * @description: 目标设置 - 查询部门下的用户
 * @return {*}
 */
export const queryDeptUserListForGoal = (): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/queryDeptUserList ',
    method: 'GET',
  })
}

/**
 * @description: 目标设置 - 查询业绩列表
 * @return {*}
 */
export const queryPerformanceTargetListForGoal = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/queryPerformanceTargetList',
    method: 'POST',
    data
  })
}

/**
 * @description: 目标设置 - 业绩详情
 * @return {*}
 */
export const queryTargetInfo = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/queryTargetInfo',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 目标设置 - 设置业绩目标
 * @return {*}
 */
export const addPerformanceTarget = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/addPerformanceTarget',
    method: 'POST',
    data
  })
}

/**
 * @description: 目标设置 - 编辑业绩目标
 * @return {*}
 */
export const updatePerformanceTarget = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceTargetSet/updatePerformanceTarget',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为-跟进行为报表3.0
 * @return {*}
 */
export const getCustomerFollowUpV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getCustomerFollowUpV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-跟进记录明细3.0
 * @return {*}
 */
export const getCustomerFollowDetailV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getCustomerFollowDetailV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为-跟进客户明细3.0
 * @return {*}
 */
export const getCustomerDetailV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getCustomerDetailV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-拜访签到报表3.0
 * @return {*}
 */
export const getVisitDataStatisticsV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getVisitDataStatisticsV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-拜访签到明细
 * @return {*}
 */
export const getPersonVisitV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getPersonVisitV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-通话量分析3.0
 * @return {*}
 */
export const getCallStatisticsV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getCallStatisticsV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 销售行为看板-通话量明细3.0
 * @return {*}
 */
export const getCallDetailV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/getCallDetailV3',
    method: 'POST',
    data
  })
}

/**
 * @description: 业绩完成情况列表
 * @return {*}
 */
export const queryPerformanceCompletionV3List = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceV3/queryPerformanceCompletionV3List',
    method: 'POST',
    data
  })
}

/**
 * @description: 业绩汇总
 * @return {*}
 */
export const queryPerformanceSummary = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceV3/queryPerformanceSummary',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户分析-客户数量概览
 * @return {*}
 */
export const customerQuantityStatistics = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/customerQuantityStatistics',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户数量概览-客户列表明细
 * @return {*}
 */
export const customerDetail = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/customerDetail',
    method: 'POST',
    data
  })
}

/**
 * @description: 新增客户明细
 * @return {*}
 */
export const addCustomerStatistics = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/addCustomerStatistics',
    method: 'POST',
    data
  })
}

/**
 * @description: 产品销售分析
 * @return {*}
 */
export const queryProductSales = (data?: any): any => {
  return request({
    url: 'zqcrm/productSalesAnalysisV3/queryProductSales',
    method: 'POST',
    data
  })
}

/**
 * @description: 渠道列表
 * @return {*}
 */
export const queryChannelConversionList = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/queryChannelConversionList',
    method: 'GET',
  })
}

/**
 * @description: 渠道转化分析列表
 * @return {*}
 */
export const channelConversion = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/channelConversion',
    method: 'POST',
    data
  })
}

/**
 * @description: 客户来源分析
 * @return {*}
 */
export const customerSourceAnalysis = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/customerSourceAnalysis',
    method: 'POST',
    data
  })
}

/**
 * @description: 导出客户数量概览
 * @return {*}
 */
export const exportCustomerQuantity = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/exportCustomerQuantity',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出新增客户明细列表
 * @return {*}
 */
export const exportAddCustomerStatistics = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/exportAddCustomerStatistics',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出客户来源分析列表
 * @return {*}
 */
export const exportCustomerSourceAnalysis = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/exportCustomerSourceAnalysis',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出业绩完成情况
 * @return {*}
 */
export const exportPerformanceCompletion = (data?: any): any => {
  return request({
    url: 'zqcrm/performanceV3/exportPerformanceCompletion',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出产品销售分析列表
 * @return {*}
 */
export const exportProductSales = (data?: any): any => {
  return request({
    url: 'zqcrm/productSalesAnalysisV3/exportProductSales',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出渠道转化分析列表
 * @return {*}
 */
export const exportChannelConversion = (data?: any): any => {
  return request({
    url: 'zqcrm/customerAnalyticsV3/exportChannelConversion',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出通话量分析列表
 * @return {*}
 */
export const exportCallInfoDeptV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/exportCallInfoDeptV3',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出通话流水明细列表
 * @return {*}
 */
export const exportCallDetailV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/exportCallDetailV3',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 导出拜访签到分析列表
 * @return {*}
 */
export const exportVisitDataStatisticsDeptV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/exportVisitDataStatisticsDeptV3',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 跟进行为分析导出
 * @return {*}
 */
export const exportCustomerFollowV3 = (data?: any): any => {
  return request({
    url: 'zqcrm/salesPracticesV3/exportCustomerFollowV3',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 预测成单金额报表
 * @return {*}
 */
export const queryPredictOrderAmount = (data?: any): any => {
  return request({
    url: 'zqcrm/productSalesAnalysisV3/queryPredictOrderAmount',
    method: 'POST',
    data,
  })
}

/**
 * @description: 预测成单金额报表导出
 * @return {*}
 */
export const exportPredictOrderAmount = (data?: any): any => {
  return request({
    url: 'zqcrm/productSalesAnalysisV3/exportPredictOrderAmount',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 客户管理 - 客户查重 新增客户
 * @return {*}
 */
export const recommendCustomer = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/recommendCustomer',
    method: 'POST',
    data,
  })
}

/**
 * @description: 渠道列表
 * @return {*}
 */
export const queryChannels = (data?: any): any => {
  return request({
    url: 'zqcrm/customer/channels',
    method: 'GET',
  })
}

/**
 * @description: 客户管理 - 服务客户
 * @return {*}
 */
export const queryServiceCustomerList = (data?: any): any => {
  return request({
    url: 'zqcrm/customerStatusTag/queryServiceCustomerList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 基础设置 - 顾问任务配置 - 列表
 * @return {*}
 */
export const queryConsultantSetList = (data?: any): any => {
  return request({
    url: 'zqcrm/consultantSet/list',
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 基础设置 - 顾问任务配置 - 编辑
 * @return {*}
 */
export const queryConsultantSetUpdate = (data?: any): any => {
  return request({
    url: 'zqcrm/consultantSet/update',
    method: 'POST',
    data,
  })
}

/**
 * @description: 基础设置 - 顾问任务配置 - 配置工单
 * @return {*}
 */
export const consultantSetUpdate = (data: any): any => {
  return request({
    url: 'zqcrm/consultantSet/update',
    method: 'POST',
    data,
  })
}

/**
 * @description: 工单池 - 导出
 * @return {*}
 */
export const exportWorkPoolList = (data?: any): any => {
  return request({
    url: 'zqcrm/work/exportWorkPoolList',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 待接收 - 导出
 * @return {*}
 */
export const exportToBeReceivedList = (data?: any): any => {
  return request({
    url: 'zqcrm/work/exportToBeReceivedList',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

/**
 * @description: 受理中 - 导出
 * @return {*}
 */
export const exportAcceptingList = (data?: any): any => {
  return request({
    url: 'zqcrm/work/exportAcceptingList',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

// 发起签约 - 填写订单信息 - 产品信息 - 抵扣券ID
export const queryDeductionListByCustomerId = (data: any): any => {
  // 查询周期性产品列表
  return request({
    url: 'zqcrm/deductionCoupon/queryDeductionListByCustomerId',
    method: 'GET',
    params: data,
  })
}
